export default "__VITE_ASSET__D02OQR6M__"